module.exports = __webpack_public_path__ + "03_very_short_brown.4c3742c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_very_short_brown.png
// module id = 5/Zx
// module chunks = 0